import { lazy } from 'react';
import { getCorrespondLabel } from '@/utils/global';
const ActivityRoutes = [
    {
        label: '',
        key: 'MainLayout',
        path: '/109/:businessId/:state/',
        element: lazy(() => import('@/components/Layout/ActivityLayout')),
        children: [
            {
                label: getCorrespondLabel('109') + '首页',
                key: 'activity',
                path: 'home',
                show: true,
                element: lazy(() => import('@/page/Activity/Home/index'))
            },

            {
                label: '成绩',
                key: 'score',
                show: true,
                path: 'score',
                element: lazy(() => import('@/page/Activity/Home/achievement'))
            },
            {
                label: '证书',
                key: 'certificate',
                show: true,
                path: 'certificate',
                element: lazy(() => import('@/page/Project/Certificate/Certificate'))
            }
        ]
    }
];
export default ActivityRoutes;
